import { Button, Input, Tag } from "antd";
import {
  SearchOutlined,
  DollarOutlined,
  CommentOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
  UndoOutlined,
  LockOutlined,
  MenuOutlined,
  DisconnectOutlined,
  TagsOutlined,
  EditOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  SwapOutlined,
  DoubleRightOutlined,
  PlusOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import DeleteProduct from "../../assets/images/delete1.svg";

// ─── Shortcut Data ────────────────────────────────────────────────────────────

export const shortcutData = [
  { action: "To Choose a Product", keys: ["Alt", "C"], icon: <SearchOutlined /> },
  { action: "Go to Other Charges", keys: ["Alt", "O"], icon: <DollarOutlined /> },
  { action: "Give Remarks", keys: ["Alt", "M"], icon: <CommentOutlined /> },
  { action: "Proceed BOM Order", keys: ["Alt", "P"], icon: <CheckCircleOutlined /> },
  { action: "Cancel BOM Order", keys: ["Alt", "A"], icon: <CloseCircleOutlined /> },
  { action: "To Search Manual Products", keys: ["Alt", "S"], icon: <SearchOutlined /> },
  { action: "Production Order History", keys: ["Alt", "H"], icon: <FileTextOutlined /> },
  { action: "Reverse Order", keys: ["Alt", "V"], icon: <UndoOutlined /> },
  { action: "To Screen Lock", keys: ["Alt", "L"], icon: <LockOutlined /> },
  { action: "Open Side Bar", keys: ["Alt", "B"], icon: <MenuOutlined /> },
  { action: "Unlink Till", keys: ["Alt", "U"], icon: <DisconnectOutlined /> },
  { action: "Select Pricing Method", keys: ["Alt", "T"], icon: <TagsOutlined /> },
  { action: "Edit the Qty/unit or Total Qty", keys: ["Alt", "I"], icon: <EditOutlined /> },
  { action: "To Increase Qty", keys: ["Shift", "+"], icon: <PlusCircleOutlined /> },
  { action: "To Decrease Qty", keys: ["Shift", "-"], icon: <MinusCircleOutlined /> },
  { action: "Navigate through Products", keys: ["←", "→"], icon: <SwapOutlined /> },
  { action: "Navigate Records in Table", keys: ["↑", "↓"], icon: <DoubleRightOutlined /> },
];

// ─── Shortcuts Modal Columns ─────────────────────────────────────────────────

export const shortcutColumns = [
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (text, record) => (
      <span>
        {record.icon} <span style={{ paddingLeft: "7px" }}>{text}</span>
      </span>
    ),
  },
  {
    title: "Shortcut Keys",
    dataIndex: "keys",
    key: "keys",
    align: "right",
    render: (keys) => (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {keys?.map((key, index) => (
          <Button size="small" className="shortcutBtn1" key={index} style={{ marginLeft: 4 }}>
            {key}
          </Button>
        ))}
      </div>
    ),
  },
];

// ─── BOM Cart Table Columns ───────────────────────────────────────────────────

export const getBOMCartColumns = ({
  editingKey,
  selectedInputType,
  editingValue,
  setEditingValue,
  handleEditStart,
  handleInputSubmit,
  qtyUnitInputRef,
  hasReverseOrderData,
  disableSearch,
  handleDeleteSearchedProduct,
  posConfig,
  pricePrecision,
}) => [
  {
    title: "Item",
    dataIndex: "product_name",
    key: "product_name",
    width: "21%",
    render: (text, record) => (
      <>
        <p>
          {record?.value || record?.product_value} - {record?.name || record?.product_name}
        </p>
      </>
    ),
  },
  {
    title: "UOM",
    dataIndex: "ediCode",
    key: "ediCode",
    width: "9%",
  },
  {
    title: "Qty/Unit",
    dataIndex: "weight",
    key: "weight",
    width: "12%",
    align: "center",
    render: (text, record, index) => (
      <input
        type="number"
        ref={index === 0 ? qtyUnitInputRef : null}
        value={editingKey === record.key && selectedInputType === "weight" ? editingValue : record?.weight}
        onChange={(e) => {
          const value = e.target.value;
          if (!isNaN(value) && value.trim() !== "") {
            setEditingValue(value);
          } else {
            setEditingValue("");
          }
          handleEditStart(record, "weight");
        }}
        onBlur={() => {
          handleInputSubmit();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleInputSubmit();
          }
        }}
        style={{ width: "80%", textAlign: "center", border: "0.5px solid #929890" }}
      />
    ),
  },
  {
    title: "Total Qty",
    dataIndex: "totalWeight",
    key: "totalWeight",
    width: "13%",
    align: "center",
    render: (text, record) => (
      <input
        type="number"
        value={editingKey === record.key && selectedInputType === "totalWeight" ? editingValue : record.totalWeight}
        onChange={(e) => {
          const value = e.target.value;
          if (!isNaN(value) && value.trim() !== "") {
            setEditingValue(value);
          } else {
            setEditingValue("");
          }
          handleEditStart(record, "totalWeight");
        }}
        onBlur={() => handleInputSubmit()}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleInputSubmit();
          }
        }}
        style={{ width: "80%", textAlign: "center", border: "0.5px solid #929890" }}
      />
    ),
  },
  ...(posConfig?.showComponentUnitPrice === "Y"
    ? [
        {
          title: "Unit Price",
          dataIndex: "sale_price",
          key: "sale_price",
          width: "13%",
          align: "center",
        },
      ]
    : []),
  ...(posConfig?.showComponentTotalPrice === "Y"
    ? [
        {
          title: "Total Price",
          dataIndex: "total",
          key: "total",
          width: "13%",
          align: "center",
          render: (text, record) => {
            return <div style={{ textAlign: "center" }}>{record.total?.toFixed(pricePrecision)}</div>;
          },
        },
      ]
    : []),
  {
    title: "Stock Qty",
    dataIndex: "stock",
    key: "stock",
    width: "12%",
    align: "center",
    render: (text, record) => {
      return <div style={{ textAlign: "center" }}>{record.stock}</div>;
    },
  },
  {
    title: "",
    dataIndex: "",
    key: "",
    width: 40,
    align: "center",
    render: (text, record) => (
      <img
        src={DeleteProduct}
        style={{
          cursor: hasReverseOrderData || disableSearch ? "not-allowed" : "pointer",
          height: "17px",
          width: "17px",
          opacity: hasReverseOrderData || disableSearch ? 0.5 : 1,
        }}
        onClick={(e) => {
          if (!hasReverseOrderData && !disableSearch) {
            e.stopPropagation();
            handleDeleteSearchedProduct(record);
          }
        }}
      />
    ),
  },
];

// ─── MTS Modal Columns ────────────────────────────────────────────────────────

export const getMTSColumns = ({ updateChooseProductsData, handleChooseProductSelect }) => [
  {
    title: "Product",
    dataIndex: "name",
    key: "name",
    width: "30%",
  },
  {
    title: "UOM",
    dataIndex: "uom",
    key: "uom",
    width: "12%",
  },
  {
    title: "Available Qty",
    dataIndex: "qtyonhand",
    key: "qtyonhand",
    width: "18%",
  },
  {
    title: "Required Qty",
    key: "requiredQty",
    width: "25%",
    render: (_, record) => (
      <Input
        value={record.requiredQuantity}
        onChange={(e) => updateChooseProductsData(record.m_product_id, e.target.value)}
        style={{ width: "100%", borderRadius: "6px" }}
      />
    ),
  },
  {
    title: "Action",
    key: "action",
    width: "15%",
    render: (_, record) => (
      <Button type="default" onClick={() => handleChooseProductSelect(record)} disabled={!record.requiredQuantity > 0} style={{ borderRadius: "6px" }}>
        Select
      </Button>
    ),
  },
];

// ─── MTO Modal Columns ────────────────────────────────────────────────────────

export const getMTOColumns = ({ updateChooseProductsData, handleChooseProductSelect }) => [
  {
    title: "Finished Good",
    dataIndex: "product",
    key: "product",
    width: "22%",
  },
  {
    title: "UOM",
    dataIndex: "uom",
    key: "uom",
    width: "8%",
  },
  {
    title: "Indent Qty",
    dataIndex: "qtyrequested",
    key: "qtyrequested",
    width: "12%",
  },
  {
    title: "Available Qty",
    dataIndex: "qtyavailable",
    key: "qtyavailable",
    width: "14%",
  },
  {
    title: "Required Qty",
    key: "requiredQuantity",
    width: "18%",
    render: (_, record) => (
      <Input
        value={record.requiredQuantity}
        onChange={(e) => updateChooseProductsData(record.m_product_id, e.target.value)}
        style={{ width: "100%", borderRadius: "6px" }}
      />
    ),
  },
  {
    title: "Status",
    key: "status",
    width: "14%",
    align: "center",
    render: (_, record) => (
      <Tag style={{ textAlign: "center" }} color={record?.status === "Issued" ? "green" : "orange"}>
        {record?.status || "Pending"}
      </Tag>
    ),
  },
  {
    title: "Action",
    key: "action",
    width: "12%",
    align: "center",
    render: (_, record) => (
      <Button
        icon={<PlusOutlined />}
        style={{ borderRadius: "4px", backgroundColor: "#9e9e9e", borderColor: "#9e9e9e", color: "white" }}
        onClick={() => handleChooseProductSelect(record)}
        disabled={!record.requiredQuantity > 0}
      />
    ),
  },
];

// ─── Other Charges Table Columns ─────────────────────────────────────────────

export const getOtherChargesColumns = ({ tempOtherChargesData, setTempOtherChargesData, savingOtherChargesDataFn, setOtherChargesData, setOtherCharges, firstInputRef }) => [
  {
    title: "Charge Name",
    dataIndex: "name",
    key: "name",
    width: "32%",
  },
  {
    title: "Charge Amount",
    dataIndex: "weight",
    key: "weight",
    width: "22%",
    align: "center",
    render: (text, record, index) => {
      return (
        <Input
          style={{ width: "10vw", textAlign: "right", border: "1px solid #92909880" }}
          value={record?.weight}
          ref={index === 0 ? firstInputRef : null}
          onPressEnter={(e) => {
            e.preventDefault();
            savingOtherChargesDataFn(tempOtherChargesData);
            setOtherChargesData(tempOtherChargesData);
            setOtherCharges(false);
          }}
          onChange={(ev) => {
            let updatedWeight = ev.target.value;
            let sanitizedValue = updatedWeight.replace(/[^0-9.]/g, "");
            if (sanitizedValue.startsWith(".")) {
              sanitizedValue = "";
            }
            const parts = sanitizedValue.split(".");
            if (parts.length > 2) {
              sanitizedValue = parts[0] + "." + parts.slice(1).join("");
            }
            let updatedTempData = tempOtherChargesData?.map((item) => (item.name === record.name ? { ...item, weight: sanitizedValue } : item));
            setTempOtherChargesData(updatedTempData);
          }}
        />
      );
    },
  },
];

// ─── Stock Validation Modal Columns ──────────────────────────────────────────

export const getStockValidationColumns = (activeTabKey) => [
  {
    title: "Item Name",
    dataIndex: "product_name",
    key: "product_name",
    width: "25%",
    render: (text, record) => {
      return <div style={{ textAlign: "left" }}>{`${record?.product_value}- ${record?.product_name}`}</div>;
    },
  },
  {
    title: "Required Qty",
    dataIndex: "weight",
    key: "weight",
    width: "12%",
    render: (text, record) => {
      return <div style={{ textAlign: "left" }}>{activeTabKey === "1" ? record?.weight : record?.totalWeight}</div>;
    },
  },
  {
    title: "Stock Qty",
    dataIndex: "stock",
    key: "stock",
    width: "10%",
    render: (text, record) => {
      return <div style={{ textAlign: "left", color: record.stock - record.weight > 0 ? "#0F0718" : "red" }}>{record?.stock ?? 0}</div>;
    },
  },
];
